import PageHeader from "@/components/PageHeader";
import { ContractorsAssignmentsForm } from "@/modules/projects/components/contractors-assignments/components/ContractorsAssignmentsForm";
import { useProjectBreadcrumb } from "@/modules/projects/hooks/useProjectBreadcrumb";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";
import { useProjectQuery } from "@/modules/projects/hooks/useProjectQuery";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { ContractorsAssignmentsAddDialog } from "./ContractorsAssignmentsAddDialog";
import { ContractorsAssignmentsContextProvider } from "./ContractorsAssignmentsContext";

export const ContractorsAssignmentsRoleBasedDirectory = memo(() => {
  const projectId = useProjectId();
  const projectQuery = useProjectQuery(projectId);

  const { t } = useTranslation();
  const title = t("projects.breadcrumb.roleBasedContractorsAssignments");

  const breadcrumbItems = useProjectBreadcrumb(projectQuery, [
    {
      label: title,
    },
  ]);

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} title={title} />
      <ContractorsAssignmentsContextProvider isRoleBasedProject>
        <ContractorsAssignmentsForm />
        <ContractorsAssignmentsAddDialog />
      </ContractorsAssignmentsContextProvider>
    </>
  );
});
